var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BonusCode"},[_c('BasiceLayout',{staticClass:"bonus-code-layout revenue-all-layout",attrs:{"title":_vm.$t('revenue_data_text')}},[_c('RevenueContent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }